import { useEffect, useState } from 'react';
import axios from 'axios';

// Fetch deployment scope from /health once per browser session. Cached in
// sessionStorage so consumers can call this hook from many mount points
// (sidebar + every route guard) without re-hitting /health each time.
// Falls back to 'platform-admin' on error so guards don't over-restrict
// on an unreachable /health probe. D-01/D-02/V-02/V-03/V-05: on
// ch.getregure.com the scope is regional-eu, which restricts SaaS God
// admin to Account Settings both in the sidebar AND at route entry.
const DEPLOY_SCOPE_KEY = 'regure.deployment.scope';

export default function useDeploymentScope() {
  const [scope, setScope] = useState(() => {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(DEPLOY_SCOPE_KEY);
  });
  useEffect(() => {
    if (scope) return;
    const base = process.env.REACT_APP_BASE_URL || '';
    const healthUrl = base.replace(/\/api\/v1\/?$/, '') + '/health';
    axios.get(healthUrl).then(({ data }) => {
      const s = String(data?.deployment?.scope || 'platform-admin').toLowerCase();
      try { sessionStorage.setItem(DEPLOY_SCOPE_KEY, s); } catch {}
      setScope(s);
    }).catch(() => {
      try { sessionStorage.setItem(DEPLOY_SCOPE_KEY, 'platform-admin'); } catch {}
      setScope('platform-admin');
    });
  }, [scope]);
  return scope;
}
